module.exports = __webpack_public_path__ + "static/img/img_title_15.baa1e50.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_title_15.png
// module id = 565
// module chunks = 1